import * as Yup from 'yup';

const questionSchema = Yup.object().shape({
  questionAnnouncement: Yup.string().required('L\'énoncé de la question est obligatoire'),
  answerA: Yup.string().required('La réponse A est obligatoire'),
  answerB: Yup.string().required('La réponse B est obligatoire'),
  answerC: Yup.string().required('La réponse C est obligatoire'),
  answerD: Yup.string().required('La réponse D est obligatoire'),
  correctAnswers: Yup.array().of(Yup.string()).min(1, 'Au moins une bonne réponse est requise'),
  category: Yup.string().required('La catégorie est obligatoire')
});

export const validationSchema = Yup.object().shape({
  title: Yup.string()
    .required('Le titre est obligatoire')
    .min(3, 'Le titre doit contenir au moins 3 caractères'),
  category: Yup.string()
    .required('La catégorie est obligatoire')
    .min(2, 'La catégorie doit contenir au moins 2 caractères'),
  description: Yup.string()
    .required('La description est obligatoire')
    .min(10, 'La description doit contenir au moins 10 caractères'),
  questions: Yup.array()
    .of(questionSchema.nullable())
    .nullable()
    .default([])
});

// Separate validation schema for the final step
export const finalStepValidation = validationSchema.shape({
  questions: Yup.array()
    .of(questionSchema)
    .min(1, 'Au moins une question est requise')
    .required('Les questions sont obligatoires')
});
